import { styled } from "@mui/material";

export const QuickEditInput = styled("input")(({ theme }) => ({
  width: "fit-content",
  background: "white",
  maxWidth: "100%",
  border: "1px solid transparent",
  padding: 0,
  borderColor: theme.palette.primary.main,
  borderRadius: `${theme.shape.borderRadius}px !important`,
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  marginLeft: theme.spacing(-0.5), // This might need adjustment based on EditableBox padding
  "&:focus-visible": {
    outline: "none",
  },
}));
